import React from 'react';

import ArrowUpCircleIcon from '@atlaskit/icon-lab/core/arrow-up-circle';
import WarningOutlineIcon from '@atlaskit/icon-lab/core/warning-outline';
import CreditCardIcon from '@atlaskit/icon/core/credit-card';

import { type IconType } from '../services/use-button-content';

export function getIconElement(icon: IconType | undefined): JSX.Element | undefined {
	if (icon === 'warning') {
		return <WarningOutlineIcon label="" />;
	}
	if (icon === 'credit-card') {
		return <CreditCardIcon label="" />;
	}
	if (icon === 'arrow-up-circle') {
		return <ArrowUpCircleIcon label="" />;
	}
	return undefined;
}
